import { createFileRoute } from '@tanstack/react-router'
import { TripPlannerPage } from '@/pages/trip-planner'

export const Route = createFileRoute('/_authenticated/trip-planner')({
  component: TripPlannerPage,
})